module.exports = __webpack_public_path__ + "static/media/organization.01a74660.svg";